export default __webpack_public_path__ + "static/font-5849961512950797985f92edf1c82947.woff";